"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var store_1 = require("../../store");
var hooks_1 = require("../../hooks");
var LayoutController = function () {
    var setMenuFullCollapsed = store_1.useActions(function (state) { return state.ui.setMenuFullCollapsed; });
    var setMenuIconCollapsed = store_1.useActions(function (state) { return state.ui.setMenuIconCollapsed; });
    var setMasterAreaCollapsed = store_1.useActions(function (state) { return state.ui.setMasterAreaCollapsed; });
    var setHelpAreaCollapsed = store_1.useActions(function (state) { return state.ui.setHelpAreaCollapsed; });
    var setIsMobile = store_1.useActions(function (state) { return state.ui.setIsMobile; });
    var breakpoint = hooks_1.useBreakpoint();
    var smBreakpoint = function () {
        setHelpAreaCollapsed(true);
        setMenuFullCollapsed(true);
        setMasterAreaCollapsed(true);
        setIsMobile(true);
    };
    var mdBreakpoint = function () {
        setHelpAreaCollapsed(true);
        setMenuIconCollapsed(true);
        setMasterAreaCollapsed(true);
        setIsMobile(false);
    };
    var lgBreakpoint = function () {
        setHelpAreaCollapsed(true);
        setMenuIconCollapsed(true);
        setMasterAreaCollapsed(false);
        setIsMobile(false);
    };
    var xlBreakpoint = function () {
        setHelpAreaCollapsed(true);
        setMenuFullCollapsed(false);
        setMasterAreaCollapsed(false);
        setIsMobile(false);
    };
    if (breakpoint === 'sm')
        smBreakpoint();
    else if (breakpoint === 'md')
        mdBreakpoint();
    else if (breakpoint === 'lg')
        lgBreakpoint();
    else
        xlBreakpoint();
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = LayoutController;
